const metricCountLabel = (count, language) => {
  if (language !== 'cs') {
    return `${count} ${count === 1 ? 'metric' : 'metrics'} above threshold`;
  }
  if (count === 1) return '1 metrika nad prahem';
  if (count >= 2 && count <= 4) return `${count} metriky nad prahem`;
  return `${count} metrik nad prahem`;
};

export const getComplexAuditInvitationModel = ({
  language = 'cs',
  url,
  isLoading = false,
  failingVitals = []
}) => {
  const normalizedUrl = String(url || '').trim();
  if (isLoading || !normalizedUrl || !Array.isArray(failingVitals) || failingVitals.length === 0) {
    return null;
  }

  const cs = language === 'cs';
  return {
    url: normalizedUrl,
    issueCount: metricCountLabel(failingVitals.length, language),
    eyebrow: cs ? 'Doporučený další krok' : 'Recommended next step',
    title: cs ? 'Zjistěte, co web skutečně brzdí' : 'Find out what is really slowing the site down',
    description: cs
      ? 'Komplexní CWV audit naváže na právě načtená data, prověří problémové metriky v laboratoři a připraví příčiny i konkrétní zadání k nápravě.'
      : 'The complete CWV audit builds on the data you just loaded, verifies failing metrics in the lab, and prepares root causes with actionable handover tasks.',
    runtime: cs
      ? 'Běží na serveru · obvykle 10–20 minut'
      : 'Runs on the server · usually 10–20 minutes',
    cta: cs ? 'Spustit komplexní audit' : 'Run complete audit',
    ctaLabel: cs
      ? `Spustit komplexní audit pro ${normalizedUrl}`
      : `Run a complete audit for ${normalizedUrl}`
  };
};